/**
 * Volta à rota pedida após o login (ex.: /autorizar?state=… do DeliDesk).
 * Só aceita path relativo interno — evita open redirect.
 */

const STORAGE_KEY = "delivai_post_login_redirect";
const TTL_MS = 10 * 60 * 1000;

export function safeInternalRedirect(raw: string | null | undefined): string | null {
  if (!raw || typeof raw !== "string") return null;
  let value = raw.trim();
  if (!value) return null;
  try {
    if (value.startsWith("%2F") || value.startsWith("%2f")) {
      value = decodeURIComponent(value);
    }
  } catch {
    return null;
  }
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  return value;
}

export function rememberPostLoginRedirect(path: string): void {
  const safe = safeInternalRedirect(path);
  if (!safe) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ path: safe, exp: Date.now() + TTL_MS })
    );
  } catch {
    /* ignore */
  }
}

export function peekPostLoginRedirect(queryRaw?: string | null): string | null {
  const fromQuery = safeInternalRedirect(queryRaw);
  if (fromQuery) return fromQuery;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { path?: unknown; exp?: unknown };
    if (typeof parsed.exp === "number" && parsed.exp < Date.now()) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return safeInternalRedirect(typeof parsed.path === "string" ? parsed.path : null);
  } catch {
    return null;
  }
}

export function clearPostLoginRedirect(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
